module.exports = __webpack_public_path__ + "static/img/renwutongbu2.fc6613f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/renwutongbu2.png
// module id = H4XK
// module chunks = 24